export class Watershed {
    constructor(
        public watershedId: string,
        public watershedName: string
        ){}
}
